<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="storageModal" tabindex="-1" role="dialog" aria-labelledby="storageModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="col-md-6 text-left">
              <h5 class="modal-title"> Storage Cost Analysis  </h5>
            </div>
            <div v-if="storageData.maxStorageSize" class="col-md-6 text-right">
              <h5 class="modal-title"> Total Storage: {{storageData.maxStorageSize}} GB  </h5>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                Please select month:
                <select v-model="selectedMonth" @change="getDataForSelectedMonth()" class="form-control col-md-12 mt-2">
                  <option  v-for="(opt, d_index) of monthArray" :disabled="opt.key > currentMonth" :value="opt" :key="d_index">{{opt.value}}</option>
                </select>
              </div>
              <div class="col-md-6">
                Select year:
                <select v-model="selectedYear" @change="getDataForSelectedMonth()" class="form-control col-md-12 mt-2">
                  <option  v-for="(opt, d_index) of years" :value="opt" :key="d_index">{{opt}}</option>
                </select>
              </div>
            </div>
            <div v-show="loading" class="loader"></div>
            <section class="mt-4" v-if="array.length > 0">
              <div class="text-center">
                <h3>{{selectedMonth.value}}, {{currentYear}}</h3>
              </div>
              <div class="row">
                <div class="col-md-2">
                  <b>Day</b>
                </div>
                <div class="col-md-2">
                  <b>File Storage Usage</b>
                </div>
                <div class="col-md-2">
                  <b>Database Storage Usage</b>
                </div>
                <div class="col-md-2">
                  <b>Total Storage Usage</b>
                </div>
                <div class="col-md-2">
                  <b>Cost</b>
                </div>
                <div class="col-md-2">
                  <b>Difference</b>
                </div>
              </div>
                <perfect-scrollbar class="scroll-area">
                  <div class="row macro" v-for="(row, index) of array" :key="index">
                    <div class="col-md-2">
                      {{row.day}}
                    </div>
                    <div class="col-md-2">
                      {{row.file.value}} {{row.file.unit}}
                    </div>
                    <div class="col-md-2">
                      {{row.database.value}} {{row.database.unit}}
                    </div>
                    <div class="col-md-2">
                      {{row.total.value}} {{row.total.unit}}
                    </div>
                    <div class="col-md-2">
                      {{row.cost}}
                    </div>
                    <div class="col-md-2">
                      {{row.difference}}
                    </div>
                  </div>
                </perfect-scrollbar>
              <div v-if="storageData.averageCost && storageData.totalCost" class="row mt-4">
                <div class="col-md-6">
                  <h3>Average Cost: {{storageData.averageCost}}</h3>
                </div><div class="col-md-6 text-right">
                  <h3>Total Cost: {{storageData.totalCost}}</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12 text-right">
                  <button class="btn btn-primary ">Generate Invoice </button>
                </div>

              </div>
            </section>
            <section v-if="array.length==0 && selectedMonth.value && !loading">
              <div class="row">
                <div class="col-sm-12 mt-4 col-md-12 col-lg-12 text-center">
                  <h5>No data found!</h5>
                </div>

              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";

import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
export default {
  name: "storageModal",
  components: {
    PerfectScrollbar
  },
  data(){
    return {
      storageData: {},
      domain: null,
      monthArray: [{key: 1, value: 'Jan'},
        {key: 2, value: 'Feb'},
        {key: 3, value: 'Mar'},
        {key: 4, value: 'Apr'},
        {key: 5, value: 'May'},
        {key: 6, value: 'Jun'},
        {key: 7, value: 'Jul'},
        {key: 8, value: 'Aug'},
        {key: 9, value: 'Sep'},
        {key: 10, value: 'Oct'},
        {key: 11, value: 'Nov'},
        {key: 12, value: 'Dec'},
      ],
      selectedMonth: {},
      array: [],
      loading: false,
      selectedYear: new Date().getFullYear(),
      currentMonth: new Date().getMonth() + 1,
    }
  },
  computed: {
    docID() {
      return this.$store.getters["customer/docID"];
    },
    years () {
      const array = [2021];
      const currentYear = new Date().getFullYear();
      let year = 2022;
      while (year <= currentYear) {
        array.push(year)
        year++;
      }
      return array;
    }
  },
  watch: {
    selectedYear () {
      const currentYear = new Date().getFullYear();
      if (this.selectedYear === currentYear) {
        this.currentMonth = new Date().getMonth();
      } else {
        this.currentMonth = 12
      }
    }
  },
  methods: {
    load (data) {
      this.loading=true
      // this.storageArray=data.storageArray
      this.selectedMonth={}
      this.array=[]
      this.domain=data.domain
      this.storageData.maxStorageSize=data.maxStorageSize
      $('#storageModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
      this.loading=false
    },
    async getDataForSelectedMonth() {
      if (!this.selectedYear || !this.selectedMonth.key) {
        return;
      }
      this.loading=true
      this.array=[]
      let response = await db.collection('hostingAccounts').doc(this.docID).collection('billings').where('year', '==', this.selectedYear).where('month', '==', this.selectedMonth.key).where('domain', '==', this.domain).get();
      response.forEach(doc => {
        let el = doc.data()
        if (el.billingUnits && el.billingUnits.length > 0) {
          el.billingUnits.map(el1 => {
            this.array.push({...el1})
          })
        }
        console.log(this.array)
        this.storageData.totalCost=el.totalCost
        this.storageData.averageCost=el.averageCost
      });
      this.loading=false
    }
  }
}
</script>

<style scoped>
.scroll-area {
  max-height: 400px;
  overflow: hidden;
}
.row.macro {
  padding: 10px;
  margin-bottom: 2px;
  border-bottom: 1px solid #9b9696;
}
</style>
